/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WebApiModelsEnumerationTypesEmailDesignTemplate } from './WebApiModelsEnumerationTypesEmailDesignTemplate';
import {
    WebApiModelsEnumerationTypesEmailDesignTemplateFromJSON,
    WebApiModelsEnumerationTypesEmailDesignTemplateFromJSONTyped,
    WebApiModelsEnumerationTypesEmailDesignTemplateToJSON,
} from './WebApiModelsEnumerationTypesEmailDesignTemplate';

/**
 * 
 * @export
 * @interface WebApiServicesDataTransferObjectsEmailServiceEmailTemplateDesignDto
 */
export interface WebApiServicesDataTransferObjectsEmailServiceEmailTemplateDesignDto {
    /**
     * 
     * @type {string}
     * @memberof WebApiServicesDataTransferObjectsEmailServiceEmailTemplateDesignDto
     */
    header?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiServicesDataTransferObjectsEmailServiceEmailTemplateDesignDto
     */
    imageUrl?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiServicesDataTransferObjectsEmailServiceEmailTemplateDesignDto
     */
    accentColor?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiServicesDataTransferObjectsEmailServiceEmailTemplateDesignDto
     */
    textColor?: string | null;
    /**
     * 
     * @type {WebApiModelsEnumerationTypesEmailDesignTemplate}
     * @memberof WebApiServicesDataTransferObjectsEmailServiceEmailTemplateDesignDto
     */
    emailDesignTemplate?: WebApiModelsEnumerationTypesEmailDesignTemplate;
}

/**
 * Check if a given object implements the WebApiServicesDataTransferObjectsEmailServiceEmailTemplateDesignDto interface.
 */
export function instanceOfWebApiServicesDataTransferObjectsEmailServiceEmailTemplateDesignDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiServicesDataTransferObjectsEmailServiceEmailTemplateDesignDtoFromJSON(json: any): WebApiServicesDataTransferObjectsEmailServiceEmailTemplateDesignDto {
    return WebApiServicesDataTransferObjectsEmailServiceEmailTemplateDesignDtoFromJSONTyped(json, false);
}

export function WebApiServicesDataTransferObjectsEmailServiceEmailTemplateDesignDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiServicesDataTransferObjectsEmailServiceEmailTemplateDesignDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'header': !exists(json, 'header') ? undefined : json['header'],
        'imageUrl': !exists(json, 'imageUrl') ? undefined : json['imageUrl'],
        'accentColor': !exists(json, 'accentColor') ? undefined : json['accentColor'],
        'textColor': !exists(json, 'textColor') ? undefined : json['textColor'],
        'emailDesignTemplate': !exists(json, 'emailDesignTemplate') ? undefined : WebApiModelsEnumerationTypesEmailDesignTemplateFromJSON(json['emailDesignTemplate']),
    };
}

export function WebApiServicesDataTransferObjectsEmailServiceEmailTemplateDesignDtoToJSON(value?: WebApiServicesDataTransferObjectsEmailServiceEmailTemplateDesignDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'header': value.header,
        'imageUrl': value.imageUrl,
        'accentColor': value.accentColor,
        'textColor': value.textColor,
        'emailDesignTemplate': WebApiModelsEnumerationTypesEmailDesignTemplateToJSON(value.emailDesignTemplate),
    };
}

